/* eslint-disable @typescript-eslint/no-unused-vars */
import Eventable from 'utils/eventable';
import { copyProperties } from 'utils/mixin';
import type { Player } from '../../../../types';
import type { ConfigModel } from '../playback/config';

type InternalPlayer = Player & { config: ConfigModel };

class PluginModel<TOpts = undefined> extends Eventable {
    player: InternalPlayer;
    el: null | HTMLElement;
    constructor(options: TOpts) {
        super();

        this.player = null!;
        this.el = null;

        if (typeof this.initialize === 'function') {
            this.initialize(options);
        }
    }

    getName() {
        throw new Error('getName() method has to be implemented');
    }

    initialize(_options: TOpts) {}

    setup(_player: Player) {}

    destroy() {}

    setPlayer(player: InternalPlayer) {
        this.player = player;
        this.setup(player);
    }
}

const createClass = <TImpl, TOpts>(plugin: TImpl) => {
    class CustomPluginModel extends PluginModel<TOpts> {}
    copyProperties(CustomPluginModel.prototype, plugin);
    return CustomPluginModel as unknown as PluginModel<TOpts> & TImpl;
};

export { createClass, PluginModel };
